import React from "react";
import { Card, Button } from "antd";
import "./OrangeBtn.scss";

const OrangeBtn = ({ text, imgSrc, alt = "icon", onClick, loading = false, disable = false, htmlType, type }) => {
  return (
    <Card className="orangeBtnMain">
      <Button className="button_main" type="primary" htmlType={htmlType || type} onClick={onClick} loading={loading} disabled={disable}>
        {imgSrc && <img src={imgSrc} alt={alt} className="btn_icon" />}
        {text}
      </Button>
    </Card>
  );
};

export default OrangeBtn;
